import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { seAdditionalDocServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import SeAdditionalDocNewPage from "../views/pages/additionalDoc/SeAdditionalDocNewPage";

export const seAdditionalDocRoutes = [
  {
    path: "/se-additional-doc",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={seAdditionalDocServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/se-additional-doc/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage
          serviceConfig={seAdditionalDocServiceConfig}
          wrappedPage={<SeAdditionalDocNewPage />}
        />
      </SecurityGuard>
    ),
  },
];
